<template>
    <div>
        <q-score-card key="QScoreCardConservedPolicies" title="Conserved Policies" api-endpoint="conserved_policies" drill-down-label="Policy Breakdown" drill-down-route="Drilldown_ConservedPolicies" card-style="production" :agent-code="agentCode" :filters="filters" :default-goal="defaultGoal" format="Currency">
            Note: Conserved Policies stats are only available after the end of the month - updated once a month.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardConservedPolicies",
    props: ["agentCode", "filters", "defaultGoal"],
    data() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {
	},
    computed: {

    },
    methods: {

    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
